import { ref } from 'vue'
import type { Ref } from 'vue'
import { fetchGalleryStorage } from '@/api/galleries'
import type { GalleryStorageSummary } from '@/types/galleries'

export function useGalleryStorage(eventSlug: string): {
  summary: Ref<GalleryStorageSummary | null>
  loading: Ref<boolean>
  error: Ref<boolean>
  fetch: () => Promise<void>
} {
  const summary = ref<GalleryStorageSummary | null>(null)
  const loading = ref(false)
  const error = ref(false)

  async function fetch(): Promise<void> {
    loading.value = true
    error.value = false
    try {
      summary.value = await fetchGalleryStorage(eventSlug)
    } catch {
      // The page stays usable without the meter.
      error.value = true
    } finally {
      loading.value = false
    }
  }

  return { summary, loading, error, fetch }
}
